/**
 * Imperative bridge so list/table filename clicks (outside PreviewGroup context)
 * can open the shared image carousel when a thumbnail is registered.
 */

type FilesImagePreviewOpener = (fileId: number) => boolean;

let filesImagePreviewOpener: FilesImagePreviewOpener | null = null;

/** Registers the active preview-group opener; pass `null` on unmount. */
export function registerFilesImagePreviewOpener(opener: FilesImagePreviewOpener | null): void {
  filesImagePreviewOpener = opener;
}

/**
 * Opens the files image carousel at `fileId` when that file has a registered thumbnail.
 * @returns `true` if the carousel opened, otherwise `false`.
 */
export function tryOpenFilesImagePreview(fileId: number): boolean {
  return filesImagePreviewOpener?.(fileId) ?? false;
}
